module.exports = __webpack_public_path__ + "media/images/icons/icon-error-large-8208c9f3c1e9285bdaa2e9f209ee18d4.svg";